import { defineMessages } from 'react-intl';

export default defineMessages({
  create: {
    id: 'App.AllManageReports.Create',
    defaultMessage: 'Create',
  },
  createdBy: {
    id: 'App.AllManageReports.CreatedBy',
    defaultMessage: 'Created By',
  },
  creationDate: {
    id: 'App.AllManageReports.CreationDate',
    defaultMessage: 'Creation Date',
  },
  download: {
    id: 'App.AllManageReports.Download',
    defaultMessage: 'Download',
  },
  info: {
    id: 'App.AllManageReports.Info',
    defaultMessage: 'Info',
  },
  inProgress: {
    id: 'App.AllManageReports.InProgress',
    defaultMessage: 'In progress',
  },
  manageReports: {
    id: 'App.AllManageReports.ManageReports',
    defaultMessage: 'Manage Reports',
  },
  report: {
    id: 'App.AllManageReports.Report',
    defaultMessage: 'Report',
  },
  reportCreated: {
    id: 'App.AllManageReports.ReportCreated',
    defaultMessage: 'Report created',
  },
  reportGenerationInProgress: {
    id: 'App.AllManageReports.ReportGenerationInProgress',
    defaultMessage: `Report creation is in progress and may take a few minutes.
      You can download the finished report from the table once it is ready`,
  },
  reportNotFound: {
    id: 'App.AllManageReports.ReportNotFound',
    defaultMessage: 'Report cannot be found',
  },
  reportPropertyFailed: {
    id: 'App.AllManageReports.ReportPropertyFailed',
    defaultMessage: '{propertyName} — Report could not be generated.',
  },
  reportPropertyFailedWithReason: {
    id: 'App.AllManageReports.ReportPropertyFailedWithReason',
    defaultMessage: '{propertyName} — {message}',
  },
  reportsCreated: {
    id: 'App.AllManageReports.ReportsCreated',
    defaultMessage: 'Reports Created',
  },
  successful: {
    id: 'App.AllManageReports.Successful',
    defaultMessage: 'Successful',
  },
  type: {
    id: 'App.AllManageReports.Type',
    defaultMessage: 'Type',
  },
  viewHistory: {
    id: 'App.AllManageReports.ViewHistory',
    defaultMessage: 'View History',
  },
  projectNames: {
    id: 'App.AllManageReports.ProjectNames',
    defaultMessage: 'Project Names',
  },
  projectNamesTooltip: {
    id: 'App.AllManageReports.ProjectNamesTooltip',
    defaultMessage:
      'Properties with same Alternative Project XML Name will be shown here',
  },
  reportNoDataAvailable: {
    id: 'App.AllManageReports.ReportNoDataAvailable',
    defaultMessage:
      'No data found for the selected filters. Update your selections and try again.',
  },
  viewEdit: {
    id: 'App.AllManageReports.ViewEdit',
    defaultMessage: 'View/Edit',
  },
  noScheduledReports: {
    id: 'App.AllManageReports.NoScheduledReports',
    defaultMessage: 'No scheduled reports exist for your portfolio.',
  },
  frequency: {
    id: 'App.AllManageReports.Frequency',
    defaultMessage: 'Frequency',
  },
  lastRun: {
    id: 'App.AllManageReports.LastRun',
    defaultMessage: 'Last Run',
  },
  nextRun: {
    id: 'App.AllManageReports.NextRun',
    defaultMessage: 'Next Run',
  },
  actionsSchedule: {
    id: 'App.AllManageReports.ActionsSchedule',
    defaultMessage: 'Schedule',
  },
  addNewSchedule: {
    id: 'App.AllManageReports.AddNewSchedule',
    defaultMessage: 'Add New Schedule',
  },
  scheduleUpdated: {
    id: 'App.AllManageReports.ScheduleUpdated',
    defaultMessage: 'Schedule updated successfully',
  },
  scheduleUpdateError: {
    id: 'App.AllManageReports.ScheduleUpdateError',
    defaultMessage: 'Failed to update schedule',
  },
  editScheduleReport: {
    id: 'App.AllManageReports.EditScheduleReport',
    defaultMessage: 'Edit Schedule',
  },
  deleteSchedule: {
    id: 'App.AllManageReports.DeleteSchedule',
    defaultMessage: 'Delete Schedule',
  },
  deleteScheduleConfirm: {
    id: 'App.AllManageReports.DeleteScheduleConfirm',
    defaultMessage: 'Are you sure you want to delete this schedule?',
  },
  portfolioLevel: {
    id: 'App.AllManageReports.PortfolioLevel',
    defaultMessage: 'Portfolio Level',
  },
  propertyLevel: {
    id: 'App.AllManageReports.PropertyLevel',
    defaultMessage: 'Property Level',
  },
});
